import { type IOrganizationForm } from '@/components/Organization';

import { useBeneficiaryContext, useSaveBeneficiary } from '../model';

import InlineOrganizationForm from './InlineOrganizationForm';

const emptyOrganization: IOrganizationForm = {
  companyName: '',
  companyWebsite: '',
  companyRegistration: '',
  street: '',
  streetNumber: '',
  city: '',
  postalCode: '',
  region: '',
  country: '',
};

// Entering a new organization creates the beneficiary, or replaces the details of the one being changed
const CreateBeneficiaryForm = () => {
  const { beneficiary, setMode } = useBeneficiaryContext();
  const saveBeneficiary = useSaveBeneficiary();

  const cancelCreating = () => setMode(beneficiary ? 'view' : 'select');

  return (
    <InlineOrganizationForm defaultValues={emptyOrganization} onSave={saveBeneficiary} onCancel={cancelCreating} />
  );
};

export default CreateBeneficiaryForm;
